import React from 'react';
import AccountDropdown from '../../patterns/AccountDropdown';
import HeaderDropdownItem from '../../patterns/HeaderNavigation/HeaderDropdownItem';
import Divider from '../../components/Divider';

type Props = {
  logout: (...args) => void;
  params: {
    retailerId?: string;
  };
  user: {
    fullName?: string;
    email: string;
  };
  retailersIds: string[];
  suppliersIds: string[];
  isOnDashboard: boolean;
};

const AccountDropdownTemplate = (props: Props) => {
  const { logout, params, user, retailersIds, suppliersIds, isOnDashboard } =
    props;

  return (
    <AccountDropdown
      logout={logout}
      params={params}
      fullName={user?.fullName || ''}
      email={user.email}
      retailers={retailersIds}
      suppliers={suppliersIds}
      context="dashboard"
    >
      <div className="flex flex-col gap-xxs">
        <div className="flex flex-col pt-xxs">
          <HeaderDropdownItem to="/dashboard/profile" text="User settings" />
          <HeaderDropdownItem
            external
            href="https://www.ordermentum.com/referral-program"
            text="Refer a supplier"
          />
        </div>
        <Divider type="regular" />
        {retailersIds.length + suppliersIds.length > 1 && !isOnDashboard && (
          <HeaderDropdownItem to="/dashboard" text="Dashboard" />
        )}
      </div>
    </AccountDropdown>
  );
};

export default AccountDropdownTemplate;
